<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-21 16:38:07
 * @LastEditTime: 2022-11-12 22:12:35
 * @LastEditors: chenguobiao
-->
<template>
  <div class="player">
    <div class="player-info flex items-center">
      <!-- 用户头像 -->
      <user-avatar
        class="player-info-cls"
        type="square"
        :size="24"
        :user="userInfo"
      />
      <countdown v-if="showCountDown" ref="clock" @timeOver="timeOver" />
      <div class="chess-question-result" v-if="showChessResult">
        <img :src="require(`@/render/assets/images/grading/icon_${correctMap[currQuestion.correct]}.png`)" />
        <span :class="[correctMap[currQuestion.correct]]">（{{currQuestion.userScore}}分）</span>
      </div>
    </div>
    <div class="error-reason" v-if="showErrorReason && currQuestion.errorReason">原因：{{getErrorReason(currQuestion.errorReason)}}</div>
    <!-- 吃子 -->
    <div class="chessman-box flex flex-wrap">
      <chessman v-for="(item, index) in captures" :key="index" :piece="item" />
      <span
        v-if="score !== undefined"
        class="player-grade inline-flex items-center"
        >({{ score }}分)</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAvatar from '@/render/components/common/user-avatar'
import Countdown from '@/render/components/common/countdown'
import Chessman from '@/render/components/common/chessman'
export default {
  name: 'PlayerInfo',
  props: {
    time: { type: String },
    captures: { type: Array, default: () => [] },
    userInfo: { type: Object, default: () => ({}) },
    score: { type: Number },
  },
  data() {
    return {
      replay: true,
      correctMap: {
        0: 'lose',
        1: 'win',
        2: 'draw'
      }
    }
  },
  components: {
    UserAvatar,
    Countdown,
    Chessman,
  },
  computed: {
    ...mapGetters('grading', ['currQuestion']),
    showCountDown() {
      return !(this.replay || this.userInfo.isAi)
    },
    showChessResult() {
      return this.replay && !this.userInfo.isAi
    },
    showErrorReason() {
      return this.replay && !this.userInfo.isAi
    }
  },
  watch: {},
  created() {
    this.replay = !!this.$route.query.testLogUid
  },
  async mounted() {},
  methods: {
    getErrorReason(errorReason) {
      if (errorReason.indexOf('未能实现将杀') > -1) {
        return errorReason.split('-')[0]
      } else {
        return errorReason
      }
    },
    start() {
      this.$refs.clock.start()
    },
    stop() {
      this.$refs.clock.stop()
    },
    timeOver(val) {
      this.$emit('timeOver', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.player {
  &-info {
    .chess-question-result {
      margin-left: val(16);
      width: val(144);
      display: flex;
      align-items: center;
      img {
        width: val(44);
      }
      span {
        text-align: center;
        width: val(100);
        font-size: val(24);
        font-weight: 500;
        &.draw {
          color: #775F4A;
        }
        &.lose {
          color: #FF8000;
        }
        &.win {
          color: #00911D;
        }
      }
    }
    &-cls {
      color: #3e2c00;
      font-size: val(24);
      font-weight: 500;
      ::v-deep {
        .userinfo__reference__account {
          margin-left: val(23);
        }
      }
    }
    ::v-deep .countdown {
      margin-left: val(24);
    }
  }
  .error-reason {
    margin-top: val(22);
    font-size: val(24);
    line-height: 1em;
    font-weight: 500;
    color: #3E2C00;
  }
  &-grade {
    font-size: val(20);
    color: #ffffff;
    height: val(80);
  }
  .chessman-box {
    padding: val(50) val(50) val(50) val(15);
    height: val(300);
    overflow: auto;
  }
}
</style>
